import React, { useMemo } from 'react';
import { useEsitoHeaders, useInfoAggiuntivaBilanciata, useInfoAggiuntivaData } from 'features/sport/hooks';

import { OverThreeWithInfoAggEstesaItemProps } from 'components/scommesseTipo/scommesseTipoEsitiOverThreeWithInfoAggEstesa';
import { ScommesseEsitoTipoCard } from 'components/scommesseEsitoTipoCard';
import { ScommesseGridMultiple } from 'components/scommesseTipo/wrappers/scommesseGridMultiple';
import { isTruthy } from 'utility/functions';
import styles from './ScommesseTipoEsitiOverThreeWithInfoAggEstesa.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export const OverThreeWithInfoAggEstesaItem = ({
  index,
  scommessaKey,
  infoAggiuntivaKey,
  gtagAction,
}: OverThreeWithInfoAggEstesaItemProps) => {
  const { t } = useTranslation();
  const headers = useEsitoHeaders(scommessaKey, infoAggiuntivaKey);
  const infoAggData = useInfoAggiuntivaData(infoAggiuntivaKey);
  const { bilanciataKey } = useInfoAggiuntivaBilanciata(scommessaKey);
  const isBilanciata = useMemo(() => bilanciataKey === infoAggiuntivaKey, [bilanciataKey, infoAggiuntivaKey]);

  if (isTruthy(headers?.length)) {
    const { descrizioneTipoScommessaWithInfoAgg, descrizioneTipoScommessaWithInfoAggTrKey } = infoAggData ?? {};
    return (
      <div key={infoAggiuntivaKey} className={styles.container}>
        <p className={styles.labelContainer}>
          {isBilanciata && <span className={styles.balanced}></span>}
          <span className={styles.label}>
            {t(descrizioneTipoScommessaWithInfoAggTrKey, descrizioneTipoScommessaWithInfoAgg)}
          </span>
        </p>
        <ScommesseGridMultiple.Row key={headers?.join('_')} index={index}>
          {headers?.map(({ key }) => (
            <ScommesseEsitoTipoCard
              type={'Quota'}
              scommessaKey={scommessaKey}
              infoAggiuntivaKey={infoAggiuntivaKey}
              key={key}
              keyEsito={key}
              backgroundType="secondary"
              gtagAction={gtagAction}
            />
          ))}
        </ScommesseGridMultiple.Row>
      </div>
    );
  }

  return <React.Fragment key={infoAggiuntivaKey} />;
};